import angular from 'angular';
import StoreSalesRankWidgetComponent from './store-sales-rank-widget-component';

export default angular.module('store-sales-rank-widget', []).component('storeSalesRankWidget', new StoreSalesRankWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/store-sales-rank/store-sales-rank-widget-module.js